
import React from 'react';
import { FaEdit, FaTrash } from '../../../utils/iconUtils';
import { AttendanceRecord } from '../../../firebase/libraryFirestoreService';

interface AttendanceTableProps {
  records: AttendanceRecord[];
  getCategoryName: (categoryId: string) => string;
  formatDate: (date: Date | string) => string;
  onEdit: (record: AttendanceRecord) => void;
  onDelete: (recordId: string) => void;
  canEdit: boolean;
  canDelete: boolean;
}

const AttendanceTable: React.FC<AttendanceTableProps> = ({
  records,
  getCategoryName,
  formatDate,
  onEdit,
  onDelete,
  canEdit,
  canDelete
}) => {
  if (records.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-gray-500 text-sm">No records to display.</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 text-xs leading-tight">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Member ID</th>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Full Name</th>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Book Title</th>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Category</th>
            <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {records.map((record) => (
            <tr key={record.id} className="hover:bg-gray-50">
              <td className="px-2 py-2 whitespace-nowrap">
                <div className="text-xs font-medium text-gray-900">
                  {formatDate(record.timeRecorded)}
                </div>
              </td>
              <td className="px-2 py-2 whitespace-nowrap font-medium text-primary-600">
                {record.memberId}
              </td>
              <td className="px-2 py-2 whitespace-nowrap">
                <div className="text-xs font-medium text-gray-900">{record.fullName}</div>
              </td>
              <td className="px-2 py-2 whitespace-nowrap text-xs text-gray-500 max-w-[200px] truncate">
                {record.bookTitle}
              </td>
              <td className="px-2 py-2 whitespace-nowrap">
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-gray-100 text-gray-800">
                  {getCategoryName(record.categoryId)}
                </span>
              </td>
              <td className="px-2 py-2 whitespace-nowrap text-xs font-medium">
                <div className="flex items-center space-x-1">
                  {canEdit && (
                    <button
                      onClick={() => onEdit(record)}
                      className="text-green-600 hover:text-green-900 p-1 rounded hover:bg-green-50"
                      title="Edit"
                    >
                      <FaEdit className="h-3 w-3" />
                    </button>
                  )}
                  {canDelete && (
                    <button
                      onClick={() => record.id && onDelete(record.id)}
                      className="text-red-600 hover:text-red-900 p-1 rounded hover:bg-red-50"
                      title="Delete"
                    >
                      <FaTrash className="h-3 w-3" />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;
